<template>
  <circle cx="8" cy="8" r="8" fill="#FF9F04" />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8.00473 4L11.3984 7.1326C11.7328 7.44132 11.5144 8 11.0592 8H10.6727V12H9.00391V9.8335C9.00391 9.55735 8.78005 9.3335 8.50391 9.3335H7.50391C7.22776 9.3335 7.00391 9.55735 7.00391 9.8335V12H5.33937V8H4.95023C4.49507 8 4.27664 7.44132 4.61109 7.1326L8.00473 4Z"
    fill="white"
  />
</template>
